import apiClient from "../api-client.js";
import { withAgencyParam } from "../utils/urlHelpers.js";

export const REPORTS_ENDPOINT = "reports/reports/";

const reportEndpoint = (reportId) => `${REPORTS_ENDPOINT}${reportId}/`;

export const reportQueryKey = (reportId, refreshKey) => ["report", reportId, refreshKey];

export const fetchReport = (reportId) => apiClient.get(reportEndpoint(reportId)).then((response) => response.data);

/** Saves one editable text; resolves to the updated report. */
export const updateReportText = (reportId, field, text) =>
  apiClient.patch(reportEndpoint(reportId), { [field]: text }).then((response) => response.data);

/** `action` is "approve" or "revert"; resolves to the updated report. */
export const changeReportStatus = (reportId, action) =>
  apiClient.post(`${reportEndpoint(reportId)}${action}/`).then((response) => response.data);

/** Starts the generation; resolves to `{ task_id }`. */
export const generateReport = (clientId, periodStart, periodEnd) =>
  apiClient
    .post(`${REPORTS_ENDPOINT}generate/`, { client: clientId, period_start: periodStart, period_end: periodEnd })
    .then((response) => response.data);

// Report prompts (ReportAIConfig), one config per agency.
export const reportAiConfigEndpoint = (agencyId) => withAgencyParam("reports/ai-config/", agencyId);

/** Same key shape as getData, so the settings page and the reports page share one cache entry. */
export const reportAiConfigQueryKey = (agencyId) => ["getData", reportAiConfigEndpoint(agencyId), 0];

export const fetchReportAiConfig = (agencyId) =>
  apiClient.get(reportAiConfigEndpoint(agencyId)).then((response) => response.data);

/** Resolves to the updated config. */
export const updateReportAiConfig = (agencyId, changes) =>
  apiClient.patch(withAgencyParam("reports/ai-config/update/", agencyId), changes).then((response) => response.data);
